(function () {
  'use strict';

  function initBoardSpecs(scope) {
    var root = scope || document;
    var containers = [];
    if (root.classList && root.classList.contains('board-specs')) {
      containers.push(root);
    } else if (root.querySelectorAll) {
      containers = Array.prototype.slice.call(root.querySelectorAll('.board-specs'));
    }
    if (!containers.length) return;
    containers.forEach(function (c) { initSingleContainer(c); });
  }

  function initSingleContainer(container) {
    if (!container) return;
    if (container.dataset.boardSpecsInit === 'true') return;
    container.dataset.boardSpecsInit = 'true';

    var shapeTabs = container.querySelectorAll('.board-specs__tabs .board-specs__tab');
    var constructionPills = container.querySelectorAll('.board-specs__construction-pills .board-specs__tab');
    var levelSelect = container.querySelector('[data-filter="level"]');
    var levelPills = container.querySelectorAll('.board-specs__level-pills .board-specs__tab');
    var budgetPills = container.querySelectorAll('.board-specs__budget-pills .board-specs__tab');
    var menus = container.querySelectorAll('.board-specs__menu');
    var filterBar = container.querySelector('[data-filterbar]');
    var cards = container.querySelectorAll('.board-card');
    var tableRows = container.querySelectorAll('.board-specs__table tbody tr');
    var countSpan = container.querySelector('.board-specs__results-count');
    var countLabel = container.querySelector('.board-specs__count-label');
    var emptyState = container.querySelector('.board-specs__empty');
    var resetBtns = container.querySelectorAll('.board-specs__empty-reset, .board-specs__filters-reset');

    var activeShape = 'all';
    var activeConstruction = 'all';
    var activeLevel = 'all';
    var activeBudget = null;

    function norm(s) { return (s || '').trim(); }
    function activeLevelValue() {
      if (levelPills && levelPills.length) return activeLevel;
      if (levelSelect) return levelSelect.value || 'all';
      return 'all';
    }
    function shouldShow(el) {
      if (activeShape !== 'all' && norm(el.dataset.shape) !== norm(activeShape)) return false;
      var lvl = activeLevelValue();
      if (lvl && lvl !== 'all') {
        /* data-level is the localized composite ("A, B"): match atomically */
        var levels = (el.dataset.level || '').split(',').map(norm);
        if (levels.indexOf(norm(lvl)) === -1) return false;
      }
      if (activeConstruction !== 'all' && norm(el.dataset.construction) !== norm(activeConstruction)) return false;
      if (activeBudget) {
        var price = Number(el.dataset.price);
        if (isNaN(price)) return false;
        if (activeBudget.min !== null && price < activeBudget.min) return false;
        if (activeBudget.max !== null && price >= activeBudget.max) return false;
      }
      return true;
    }

    function applyFilters() {
      var visibleCount = 0;

      cards.forEach(function (card) {
        var show = shouldShow(card);
        card.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });

      tableRows.forEach(function (row) {
        var show = shouldShow(row);
        row.style.display = show ? '' : 'none';
      });

      if (countSpan) {
        countSpan.textContent = visibleCount;
      }
      if (countLabel) {
        countLabel.textContent = visibleCount === 1 ? countLabel.dataset.singularLabel : countLabel.dataset.pluralLabel;
      }

      syncMenus();

      if (emptyState) {
        if (visibleCount === 0) {
          emptyState.classList.add('board-specs__empty--visible');
        } else {
          emptyState.classList.remove('board-specs__empty--visible');
        }
      }
    }

    /* Shape tab clicks */
    shapeTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        shapeTabs.forEach(function (t) {
          t.classList.remove('board-specs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('board-specs__tab--active');
        tab.setAttribute('aria-selected', 'true');
        activeShape = tab.dataset.shape;
        applyFilters();
      });
    });

    /* Construction pill clicks */
    constructionPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        constructionPills.forEach(function (p) {
          p.classList.remove('board-specs__tab--active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('board-specs__tab--active');
        pill.setAttribute('aria-selected', 'true');
        activeConstruction = pill.dataset.construction;
        applyFilters();
      });
    });

    /* Level pill clicks (segmented control, explore-lineup pattern) */
    if (levelPills && levelPills.length) {
      levelPills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          levelPills.forEach(function (p) {
            p.classList.remove('board-specs__tab--active');
            p.setAttribute('aria-selected', 'false');
          });
          pill.classList.add('board-specs__tab--active');
          pill.setAttribute('aria-selected', 'true');
          activeLevel = pill.dataset.level || 'all';
          applyFilters();
        });
      });
    }

    /* Budget tranche clicks (data-min / data-max in cents, max exclusive) */
    budgetPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        budgetPills.forEach(function (p) {
          p.classList.remove('board-specs__tab--active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('board-specs__tab--active');
        pill.setAttribute('aria-selected', 'true');
        if (pill.dataset.budget === 'all') {
          activeBudget = null;
        } else {
          activeBudget = {
            min: pill.dataset.min !== undefined ? Number(pill.dataset.min) : null,
            max: pill.dataset.max !== undefined ? Number(pill.dataset.max) : null
          };
        }
        applyFilters();
      });
    });

    /* Dropdown changes (legacy fallback, kept for compatibility) */
    if (levelSelect) levelSelect.addEventListener('change', applyFilters);

    /* Reset buttons (empty state + filters header) */
    resetBtns.forEach(function (resetBtn) {
      resetBtn.addEventListener('click', function () {
        shapeTabs.forEach(function (t) {
          t.classList.remove('board-specs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        if (shapeTabs[0]) {
          shapeTabs[0].classList.add('board-specs__tab--active');
          shapeTabs[0].setAttribute('aria-selected', 'true');
        }
        activeShape = 'all';
        constructionPills.forEach(function (p) {
          p.classList.remove('board-specs__tab--active');
          p.setAttribute('aria-selected', 'false');
        });
        if (constructionPills[0]) {
          constructionPills[0].classList.add('board-specs__tab--active');
          constructionPills[0].setAttribute('aria-selected', 'true');
        }
        activeConstruction = 'all';
        if (levelPills && levelPills.length) {
          levelPills.forEach(function (p) {
            p.classList.remove('board-specs__tab--active');
            p.setAttribute('aria-selected', 'false');
          });
          if (levelPills[0]) {
            levelPills[0].classList.add('board-specs__tab--active');
            levelPills[0].setAttribute('aria-selected', 'true');
          }
        }
        activeLevel = 'all';
        budgetPills.forEach(function (p) {
          var isAll = p.dataset.budget === 'all';
          p.classList.toggle('board-specs__tab--active', isAll);
          p.setAttribute('aria-selected', isAll ? 'true' : 'false');
        });
        activeBudget = null;
        if (levelSelect) levelSelect.value = '';
        applyFilters();
      });
    });

    /* Menus: disclosure buttons + single-choice panels */
    function menuParts(menu) {
      return { btn: menu.querySelector('.board-specs__menu-btn'), panel: menu.querySelector('.board-specs__menu-panel') };
    }
    function closeMenus(except, restoreFocus) {
      menus.forEach(function (menu) {
        if (menu === except) return;
        var m = menuParts(menu);
        if (!m.panel || m.panel.hidden) return;
        m.panel.hidden = true;
        m.btn.setAttribute('aria-expanded', 'false');
        if (restoreFocus) m.btn.focus();
      });
    }
    function syncMenus() {
      menus.forEach(function (menu) {
        var m = menuParts(menu);
        if (!m.btn || !m.panel) return;
        var active = m.panel.querySelector('.board-specs__tab--active');
        var isAll = !active || active === m.panel.querySelector('.board-specs__tab');
        var text = m.btn.querySelector('.board-specs__menu-text');
        var label = m.btn.dataset.menuLabel || '';
        var shortLabel = active ? (active.dataset.shortLabel || active.textContent.trim()) : '';
        if (text) text.textContent = isAll ? label : label + ' \u00b7 ' + shortLabel;
        menu.classList.toggle('is-active', !isAll);
      });
    }
    menus.forEach(function (menu) {
      var m = menuParts(menu);
      if (!m.btn || !m.panel) return;
      m.btn.addEventListener('click', function () {
        var willOpen = m.panel.hidden;
        closeMenus(menu, false);
        m.panel.hidden = !willOpen;
        m.btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
      m.panel.addEventListener('click', function (event) {
        if (event.target.closest('.board-specs__tab')) closeMenus(null, true);
      });
    });
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.board-specs__menu')) closeMenus(null, false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenus(null, true);
    });

    /* Hide budget tranches that match no board; hide the menu if < 2 remain */
    var budgetMenu = container.querySelector('.board-specs__menu[data-menu="budget"]');
    if (budgetMenu && budgetPills.length) {
      var populated = 0;
      budgetPills.forEach(function (pill) {
        if (pill.dataset.budget === 'all') return;
        var min = pill.dataset.min !== undefined ? Number(pill.dataset.min) : null;
        var max = pill.dataset.max !== undefined ? Number(pill.dataset.max) : null;
        var has = false;
        cards.forEach(function (card) {
          var price = Number(card.dataset.price);
          if (isNaN(price)) return;
          if ((min === null || price >= min) && (max === null || price < max)) has = true;
        });
        pill.hidden = !has;
        if (has) populated++;
      });
      if (populated < 2) budgetMenu.hidden = true;
    }

    /* Stuck state: shadow only while the bar is docked */
    if (filterBar) {
      var ticking = false;
      var updateStuck = function () {
        ticking = false;
        var top = parseFloat(getComputedStyle(filterBar).top) || 0;
        filterBar.classList.toggle('is-stuck', filterBar.getBoundingClientRect().top <= top + 1 && window.scrollY > 0);
      };
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateStuck);
      }, { passive: true });
      updateStuck();
    }

    /* Scroll reveal */
    var revealEls = container.querySelectorAll('.board-specs__reveal');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var el = entry.target;
          var parent = el.parentElement;

          if (parent && parent.classList.contains('board-specs__cards')) {
            var siblings = Array.prototype.slice.call(
              parent.querySelectorAll('.board-card')
            );
            var idx = siblings.indexOf(el);
            if (idx > -1) {
              el.style.transitionDelay = (idx * 100) + 'ms';
            }
          }

          el.classList.add('board-specs__reveal--visible');
          observer.unobserve(el);
          var clearDelay = function () { el.style.transitionDelay = ''; };
          el.addEventListener('transitionend', clearDelay, { once: true });
          setTimeout(clearDelay, 1200);
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px'
      });

      revealEls.forEach(function (el) {
        observer.observe(el);
      });

      /* Safety net: never leave content invisible (e.g. observer never fires) */
      setTimeout(function () {
        revealEls.forEach(function (el) {
          if (!el.isConnected) { observer.unobserve(el); return; }
          if (!el.getClientRects().length) return;
          if (el.getBoundingClientRect().top < window.innerHeight) {
            el.classList.add('board-specs__reveal--visible');
            observer.unobserve(el);
          }
        });
      }, 1500);
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('board-specs__reveal--visible');
      });
    }

    initBoardSpecsDrawer(container);
  }

  function initBoardSpecsDrawer(container) {
    var triggers = container.querySelectorAll('[data-board-specs-trigger]');
    var drawer = container.querySelector('[data-board-specs-drawer]');
    var overlay = container.querySelector('[data-board-specs-overlay]');
    var closeButton = container.querySelector('[data-board-specs-close]');
    var title = container.querySelector('[data-board-specs-title]');
    var image = container.querySelector('[data-board-specs-image]');
    var link = container.querySelector('[data-board-specs-link]');
    var lastTrigger = null;
    var previousOverflow = '';

    if (!triggers.length || !drawer || !overlay || !closeButton) return;

    /* Body-level teleport: a fixed overlay/drawer nested inside <main>
       paints below the sticky header group on live (verified: header
       above a z-1000 drawer). Moving both nodes to <body> lets them
       compete at root level, where 999/1000 win. Refs are element
       handles, so queries below keep working; appendChild is
       idempotent across theme-editor reloads. */
    function dropBodyStale(id, keep) {
      if (!id) return;
      Array.prototype.forEach.call(document.querySelectorAll('[id="' + id + '"]'), function (node) {
        if (node !== keep && node.parentElement === document.body) node.remove();
      });
    }
    dropBodyStale(overlay.id, overlay);
    dropBodyStale(drawer.id, drawer);
    if (overlay.parentElement !== document.body) document.body.appendChild(overlay);
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);

    var fields = ['length', 'width', 'thickness', 'volume', 'shape', 'fins', 'fin-box', 'weight', 'construction', 'shaper', 'level'];

    function formatValue(key, value) {
      if (!value) return '';
      if ((key === 'width' || key === 'thickness') && !/["″]/.test(value)) return value + '"';
      if (key === 'weight' && !/kg/i.test(value)) return value + ' kg';
      return value;
    }

    function setDrawerValue(key, value) {
      var row = drawer.querySelector('[data-spec-row="' + key + '"]');
      var valueElement = drawer.querySelector('[data-spec-value="' + key + '"]');
      if (!row || !valueElement) return;

      row.hidden = !value;
      if (!value) return;

      if (key === 'construction') {
        var badge = valueElement.querySelector('.pm-specs-drawer__badge');
        if (badge) badge.textContent = value;
      } else {
        valueElement.textContent = formatValue(key, value);
      }
    }

    function openDrawer(trigger) {
      lastTrigger = trigger;
      if (title) title.textContent = trigger.dataset.productTitle || '';
      if (link) link.href = trigger.dataset.productUrl || '#';
      if (image) {
        if (trigger.dataset.productImage) {
          image.src = trigger.dataset.productImage;
          image.alt = trigger.dataset.productTitle || '';
          image.hidden = false;
        } else {
          image.removeAttribute('src');
          image.alt = '';
          image.hidden = true;
        }
      }

      fields.forEach(function (key) {
        var datasetKey = key === 'fin-box' ? 'finBox' : key;
        setDrawerValue(key, trigger.dataset[datasetKey] || '');
      });

      previousOverflow = document.body.style.overflow;
      drawer.classList.add('pm-specs-drawer--open');
      overlay.classList.add('pm-specs-overlay--visible');
      drawer.setAttribute('aria-hidden', 'false');
      if ('inert' in drawer) drawer.inert = false;
      drawer.removeAttribute('inert');
      trigger.setAttribute('aria-expanded', 'true');
      closeButton.focus();
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('pm-specs-drawer--open');
      overlay.classList.remove('pm-specs-overlay--visible');
      drawer.setAttribute('aria-hidden', 'true');
      if ('inert' in drawer) { drawer.inert = true; } else { drawer.setAttribute('inert', ''); }
      if (lastTrigger) lastTrigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previousOverflow;
      if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openDrawer(trigger);
      });
    });

    overlay.addEventListener('click', closeDrawer);
    closeButton.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('pm-specs-drawer--open')) closeDrawer();
    });

    drawer.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusable = drawer.querySelectorAll('a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!first || !last) { event.preventDefault(); return; }
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  /* Init */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBoardSpecs();
    });
  } else {
    initBoardSpecs();
  }

  /* Theme editor reload */
  document.addEventListener('shopify:section:load', function (event) {
    initBoardSpecs(event.target);
  });
})();
